// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(vehicle_category, geo_region) {
  if (vehicle_category !== 0) {
    return {
            title_text: "కంప్లీషన్ స్కోర్",
            learn_more_text: "ఇంకా తెలుసుకోండి",
            info_btn_details: {
              video_url: undefined,
              question: "కంప్లీషన్ స్కోర్ అంటే ఏమిటి?",
              answer: "మీకు కేటాయించిన చివరి 50 ఆర్డర్‌లలో మీరు పూర్తి చేసిన మొత్తం ఆర్డర్లు కంప్లీషన్ స్కోర్ గాలెక్కించబడుతుంది. \n\n                    ఉదా: పోర్టర్ మీకు 50 ఆర్డర్‌లను కేటాయిస్తే, అందులో మీరు 40 ఆర్డర్లు పూర్తి చేస్తే, మీ కంప్లీషన్ స్కోర్ 40."
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVidTrucks(geo_region),
                question: "కంప్లీషన్ స్కోర్ అంటే ఏమిటి మరియు అది ఎందుకు ముఖ్యమైనది?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "నేను నా కంప్లీషన్ స్కోర్ను ఎలా పెంచుకోగలను?",
                answer: "అధిక కంప్లీషన్ స్కోర్ ఉండడానికి మీరు అన్ని ఆర్డర్లను యాక్సప్ట్ చేసి పూర్తీ చేయండి"
              },
              {
                video_url: undefined,
                question: "మంచి కంప్లీషన్ స్కోర్ ఎంత?",
                answer: "అత్యధికంగా సంపాదిస్తున్న పోర్టర్ భాగస్వాముల యొక్క కంప్లీషన్ స్కోర్  ఎల్లప్పుడూ 90% లేదా అంతకంటే ఎక్కువగా ఉంటుంది ."
              },
              {
                video_url: undefined,
                question: "నా కంప్లీషన్ స్కోర్ను నేను ఎందుకు చూడలేకపోతున్నాను?",
                answer: "కనీసం 50 ఆర్డర్‌లు పొందిన భాగస్వాములకు మాత్రమే స్కోర్ లెక్కించబడుతుంది"
              }
            ],
            locked_score_msg: "స్కోర్‌ను అన్‌లాక్ చేయడానికి మరిన్ని ట్రిప్‌లను యాక్సప్ట్ చేయండి",
            message_text: "ఎక్కువ కంప్లీషన్ స్కోర్‌ ఉన్న భాగస్వాములకు ఎక్కువ ఆర్డర్‌లను పొందే అవకాశాలు అధికంగా ఉంటాయి."
          };
  } else {
    return {
            title_text: "కంప్లీషన్ స్కోర్",
            learn_more_text: "ఇంకా తెలుసుకోండి",
            info_btn_details: {
              video_url: undefined,
              question: "కంప్లీషన్ స్కోర్ అంటే ఏమిటి?",
              answer: "మీకు కేటాయించిన చివరి 50 ఆర్డర్‌లలో పూర్తి చేసిన ఆర్డర్‌ల ప్రకారం పూర్తి స్కోర్ లెక్కించబడుతుంది. ఆర్డర్‌లు మీకు పింగ్ చేయబడ్డాయి కానీ మీరు మీ స్కోర్‌లో లెక్కించబడక ముందే మరొక భాగస్వామి ఆమోదించారు \n\n                    ఉదా : పోర్టర్ 50 ఆర్డర్‌లను కేటాయిస్తే మరియు మీరు 40 పూర్తి చేస్తే, పూర్తి స్కోరు 80%"
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVid2w(geo_region),
                question: "కంప్లీషన్ స్కోర్ అంటే ఏమిటి మరియు అది ఎందుకు ముఖ్యమైనది?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "నేను నా కంప్లీషన్ స్కోర్ను ఎలా పెంచుకోగలను?",
                answer: "అధిక కంప్లీషన్ స్కోర్ ఉండడానికి మీరు అన్ని ఆర్డర్లను యాక్సప్ట్ చేసి పూర్తీ చేయండి"
              },
              {
                video_url: undefined,
                question: "మంచి కంప్లీషన్ స్కోర్ ఎంత?",
                answer: "అత్యధికంగా సంపాదిస్తున్న పోర్టర్ భాగస్వాముల యొక్క కంప్లీషన్ స్కోర్  ఎల్లప్పుడూ 90% లేదా అంతకంటే ఎక్కువగా ఉంటుంది ."
              },
              {
                video_url: undefined,
                question: "నా కంప్లీషన్ స్కోర్ను నేను ఎందుకు చూడలేకపోతున్నాను?",
                answer: "కనీసం 50 ఆర్డర్‌లు పొందిన భాగస్వాములకు మాత్రమే స్కోర్ లెక్కించబడుతుంది"
              }
            ],
            locked_score_msg: "స్కోర్‌ను అన్‌లాక్ చేయడానికి మరిన్ని ట్రిప్‌లను యాక్సప్ట్ చేయండి",
            message_text: "ఎక్కువ కంప్లీషన్ స్కోర్‌ ఉన్న భాగస్వాములకు ఎక్కువ ఆర్డర్‌లను పొందే అవకాశాలు అధికంగా ఉంటాయి."
          };
  }
}

export {
  getContent ,
  
}
/* No side effect */
